'use client';

import cx from 'classnames';
import { useEffect, useState } from 'react';

import { Spinner } from '../Spinner';
import { KatexStyles } from './KatexStyles';
import styles from './markdown.module.scss';
import { MdRenderOptions, convertMarkdownToHtml } from './utils';

interface Props {
  content: string;
  className?: string;
  options?: MdRenderOptions;
}

export const MDRenderer = ({ content, className, options }: Props) => {
  const [output, setOutput] = useState('');

  useEffect(() => {
    if (!content) return;
    convertMarkdownToHtml(content, options)
      .then((html) => {
        if (!html) return;
        setOutput(html);
      })
      .catch();
  }, [output, content, options]);

  return (
    <>
      <KatexStyles />
      <aside className={cx(styles.wrapper, className)}>
        {!output && <Spinner size='small' center />}
        <div dangerouslySetInnerHTML={{ __html: output }} />
      </aside>
    </>
  );
};
